module.exports = __webpack_public_path__ + "media/applicants/device_signup_4-fr-bd1fd3ab.webp";